// ** React Imports
// ** Core Language Data
import messagesEn from '@assets/data/locales/en.json'
import messagesFr from '@assets/data/locales/fr.json'
import messagesPt from '@assets/data/locales/pt.json'
// ** User Language Data
import userMessagesRu from '@assets/data/locales/ru.json'
import userMessagesUz from '@assets/data/locales/uz.json'
import messagesDe from '@src/assets/data/locales/de.json'
import { createContext, useState } from 'react'
// ** Intl Provider Import
import { IntlProvider } from 'react-intl'

import { flattenMessages } from '../../helpers/flattenMessages'
import { getLanguage, setLanguage } from '../../helpers/storageLanguage'

// ** Menu msg obj
const menuMessages = {
  en: { ...messagesEn },
  de: { ...messagesDe },
  fr: { ...messagesFr },
  pt: { ...messagesPt },
  ru: { ...userMessagesRu },
  uz: { ...userMessagesUz },
}

// ** Create Context
const Context = createContext(getLanguage() || 'uz')

const IntlProviderWrapper = ({ children, defaultLocale }) => {
  const defaultLanguage = getLanguage() || defaultLocale

  // ** States
  const [locale, setLocale] = useState(defaultLanguage)
  const [messages, setMessages] = useState(menuMessages[defaultLanguage])

  // ** Switches Language
  const switchLanguage = lang => {
    setLocale(lang)
    setMessages(menuMessages[lang])
    setLanguage(lang)
  }

  return (
    <Context.Provider value={{ locale, switchLanguage }}>
      <IntlProvider
        key={locale}
        locale={locale}
        onError={() => {}}
        messages={flattenMessages(messages)}
        defaultLocale={defaultLanguage}
      >
        {children}
      </IntlProvider>
    </Context.Provider>
  )
}

export { IntlProviderWrapper, Context as IntlContext }
